import { createRouter, createWebHistory } from "vue-router";
import Home from "../project/Home/Home.vue";
import Files from "../project/Files/Files.vue";
import SignIn from "../project/Auth/Cover.vue";
import Request from "../project/Request/Request.vue";
import Insured from "../project/Insured/Insured.vue";
import Policy from "../project/Policy/Policy.vue";
import GroupClinic from "../project/GroupClinic/GroupClinic.vue";

const routes = [
  {
    path: "/",
    name: "/",
    redirect: "/signIn",
  },
  {
    path: "/policy/:id",
    redirect: (to) => ({ path: "/policy", query: { id: to.params.id } }),
  },
  {
    path: "/policy",
    name: "Şəhadənamə",
    component: Policy,
  },
  {
    path: "/group-clinic/:id",
    redirect: (to) => ({ path: "/group-clinic", query: { id: to.params.id } }),
  },
  {
    path: "/group-clinic",
    name: "Tibbi müəsissələri",
    component: GroupClinic,
  },
  {
    path: "/claim/insured/:id/:policyId?",
    redirect: (to) => {
      const query = { cardId: to.params.id };
      if (to.params.policyId) {
        query.policyId = to.params.policyId;
      }
      return { path: "/claim/insured", query };
    },
  },
  {
    path: "/claim/insured",
    name: "Sığortalı olunan",
    component: Insured,
  },
  {
    path: "/signIn",
    name: "SignIn",
    component: SignIn,
  },
  {
    path: "/signIn/:pathMatch(.*)+",
    redirect: (to) => {
      const segments = [].concat(to.params.pathMatch || []).filter(Boolean);
      return {
        path: "/signIn",
        query: { return: `/${segments.join("/")}` },
      };
    },
  },
  {
    path: "/request/:id",
    redirect: (to) => ({ path: "/request", query: { id: to.params.id } }),
  },
  {
    path: "/request",
    name: "Xidmət",
    component: Request,
  },
  {
    path: "/files/:id",
    redirect: (to) => ({ path: "/files", query: { id: to.params.id } }),
  },
  {
    path: "/files",
    name: "Fayllar",
    component: Files,
  },
  {
    path: "/home",
    name: "Ana səhifə",
    component: Home,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  linkActiveClass: "active",
});

export default router;
